<template>
  <button class="theme-toggle" :title="theme === 'dark' ? 'Switch to light' : 'Switch to dark'" @click="onToggle">
    {{ theme === 'dark' ? '☀' : '☾' }}
  </button>
</template>

<script>
import { getTheme, toggleTheme } from '@/utils/theme';

export default {
  name: 'ThemeToggle',
  data() {
    return { theme: getTheme() };
  },
  methods: {
    onToggle() {
      this.theme = toggleTheme();
    },
  },
};
</script>

<style scoped>
.theme-toggle {
  width: 34px;
  height: 34px;
  border-radius: var(--radius);
  border: 1px solid var(--border);
  background: var(--card);
  color: var(--muted);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  transition: .15s;
}
.theme-toggle:hover { color: var(--text); border-color: var(--border-strong); }
</style>
